import React, { Component } from 'react';
import moment from 'moment';

export default class WorkspaceTimePicker extends Component {

	constructor(props) {
		super(props);


		this.state = {
			fromYear: null,
			fromMonth: null,
			fromDay: null,
			toYear: null,
			toMonth: null,
			toDay: null,
			activeSlideIndex: 0,
			phase: 0,
			presetSelection: null
		}

		this.monthList = ['JAN', 'FEB', 'MAR', 'APR', 'MAY', 'JUN', 'JUL', 'AUG', 'SEP', 'OCT', 'NOV', 'DEC']
		this.dayList = []
		for (var i = 1; i <= 31; i++) {
			this.dayList.push((i < 10 ? "0" : "") + i.toString())
		}
		this.dayOfWeekList = ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat']

		this.intYearAdd = this.intYearAdd.bind(this);
		this.monthDayNumToInt = this.monthDayNumToInt.bind(this);
		this.monthTextToInt = this.monthTextToInt.bind(this);
		this.isSingleDate = this.isSingleDate.bind(this);
		this.getTimeRangeLabel = this.getTimeRangeLabel.bind(this);

		this.backPressed = this.backPressed.bind(this);

		this.selectPreset = this.selectPreset.bind(this);

		this.finalizeDates = this.finalizeDates.bind(this);

		this.autoSelectToday = this.autoSelectToday.bind(this);
		this.resetCalendar = this.resetCalendar.bind(this);
		this.selectFromYear = this.selectFromYear.bind(this);
		this.selectFromMonth = this.selectFromMonth.bind(this);
		this.selectFromDay = this.selectFromDay.bind(this);
		this.selectToYear = this.selectToYear.bind(this);
		this.selectToMonth = this.selectToMonth.bind(this);
		this.selectToDay = this.selectToDay.bind(this);

		this.generatePresetSlide = this.generatePresetSlide.bind(this);
		this.generateCalendarSlide = this.generateCalendarSlide.bind(this);
		this.getTimeRangeDescription = this.getTimeRangeDescription.bind(this);
	}

	componentDidUpdate(prevProps, prevState, snapshot) {
		if (this.props.isActive != prevProps.isActive && !this.props.isActive) {
			this.setState({
				fromYear: null,
				fromMonth: null,
				fromDay: null,
				toYear: null,
				toMonth: null,
				toDay: null,
				activeSlideIndex: 0,
				phase: 0,
				presetSelection: null
			});
		}
	}

	intYearAdd(yearsToAdd, dateIndex) {
		let newDate = parseInt((parseInt(dateIndex.toString().substring(0, 4)) + yearsToAdd).toString() + dateIndex.toString().substring(4, 8));
		return newDate;
	}

	monthDayNumToInt(day) {
		return day.toString().length === 1 ? "0" + day.toString() : day.toString();
	}

	monthTextToInt(month) {
		let monthList = this.monthList;

		return (monthList.indexOf(month) + 1 < 10 ? "0" : "") + (monthList.indexOf(month) + 1);
	}

	isSingleDate() {
		return this.state.presetSelection !== "custom"
	}

	getTimeRangeLabel() {
		switch (this.state.presetSelection) {
			case "single": return "Single Date"
			case "pfw": return "Previous Full Week"
			case "wtd": return "Week to Date"
			case "pf2w": return "Previous Full 2 Weeks"
			case "2wtd": return "2 Weeks to Date"
			case "pfm": return "Previous Full Month"
			case "mtd": return "Month to Date"
			case "pfq": return "Previous Full Quarter"
			case "qtd": return "Quarter to Date"
			case "pfy": return "Previous Full Year"
			case "ytd": return "Year to Date"
			default: return ""
		}
	}

	getTimeRangeDescription() {
		switch (this.state.presetSelection) {
			case "single": return "Single Date"
			case "pfw": return "Full Week prior to.."
			case "wtd": return "Start of Week to.."
			case "pf2w": return "Full 2 Weeks prior to.."
			case "2wtd": return "2 Weeks to Date"
			case "pfm": return "Full Month prior to.."
			case "mtd": return "Start of Month to.."
			case "pfq": return "Full Quarter prior to.."
			case "qtd": return "Start of Quarter to.."
			case "pfy": return "Full Year prior to"
			case "ytd": return "Start of Year to.."
			default: return "Target"
		}
	}

	backPressed() {
		this.setState({
			fromYear: null,
			fromMonth: null,
			fromDay: null,
			toYear: null,
			toMonth: null,
			toDay: null,
			activeSlideIndex: 0,
			phase: 0,
			presetSelection: null
		})
	}

	selectPreset(preset) {
		this.setState({
			fromYear: null,
			fromMonth: null,
			fromDay: null,
			toYear: null,
			toMonth: null,
			toDay: null,
			activeSlideIndex: 1,
			phase: 0,
			presetSelection: preset
		})
	}

	finalizeDates() {

		if (this.state.presetSelection === "custom") {

			let fromDateIndex = parseInt(this.state.fromYear + this.monthTextToInt(this.state.fromMonth) + this.state.fromDay);
			let toDateIndex = parseInt(this.state.toYear + this.monthTextToInt(this.state.toMonth) + this.state.toDay);

			this.props.setTimeRange(fromDateIndex, toDateIndex);
		} else {

			let strToDateIndex = this.state.fromYear + this.monthTextToInt(this.state.fromMonth) + this.state.fromDay;
			let toDateIndex = parseInt(strToDateIndex);
			let fromDateIndex = toDateIndex;

			if (this.state.presetSelection === "single") {
				this.props.setTimeRange(fromDateIndex, toDateIndex)
			} else {

				let calKey = "";
				switch (this.state.presetSelection) {
					case "pfw":
						calKey = "weeks"
						break;
					case "wtd":
						calKey = "weeks"
						break;
					case "pf2w":
						calKey = "weeks"
						break;
					case "2wtd":
						calKey = "weeks"
						break;
					case "pfm":
						calKey = "months"
						break;
					case "mtd":
						calKey = "months"
						break;
					case "pfq":
						calKey = "quarters"
						break;
					case "qtd":
						calKey = "quarters"
						break;
					case "pfy":
						calKey = "years"
						break;
					case "ytd":
						calKey = "years"
						break;
				}

				if (["pfw"].includes(this.state.presetSelection)) {
					let prevWeekEndDate = new Date(toDateIndex.toString().substring(0, 4) + "-" + toDateIndex.toString().substring(4, 6) + "-" + toDateIndex.toString().substring(6, 8));
					prevWeekEndDate.setDate(prevWeekEndDate.getDate() - 7);
					toDateIndex = parseInt(prevWeekEndDate.getFullYear().toString() + this.monthTextToInt(this.monthList[prevWeekEndDate.getMonth()]) + this.monthDayNumToInt(prevWeekEndDate.getDate()));
					fromDateIndex = toDateIndex;
				}
				else if (["pf2w"].includes(this.state.presetSelection)) {
					let prevWeekEndDate = new Date(toDateIndex.toString().substring(0, 4) + "-" + toDateIndex.toString().substring(4, 6) + "-" + toDateIndex.toString().substring(6, 8));
					prevWeekEndDate.setDate(prevWeekEndDate.getDate() - 7);
					toDateIndex = parseInt(prevWeekEndDate.getFullYear().toString() + this.monthTextToInt(this.monthList[prevWeekEndDate.getMonth()]) + this.monthDayNumToInt(prevWeekEndDate.getDate()));
					fromDateIndex = toDateIndex;
				}
				else if (["pfm"].includes(this.state.presetSelection)) {
					let prevMonthEndDate = new Date(toDateIndex.toString().substring(0, 4) + "-" + toDateIndex.toString().substring(4, 6) + "-01 11:59:00");
					prevMonthEndDate.setDate(prevMonthEndDate.getDate() - 1);
					toDateIndex = parseInt(prevMonthEndDate.getFullYear().toString() + this.monthTextToInt(this.monthList[prevMonthEndDate.getMonth()]) + this.monthDayNumToInt(prevMonthEndDate.getDate()));
					fromDateIndex = parseInt(prevMonthEndDate.getFullYear().toString() + this.monthTextToInt(this.monthList[prevMonthEndDate.getMonth()]) + "01");
				}
				else if (["pfq"].includes(this.state.presetSelection)) {
					let prevQuarterEndDate = new Date(toDateIndex.toString().substring(0, 4) + "-" + toDateIndex.toString().substring(4, 6) + "-" + toDateIndex.toString().substring(6, 8));
					prevQuarterEndDate.setMonth(prevQuarterEndDate.getMonth() - 3);
					toDateIndex = parseInt(prevQuarterEndDate.getFullYear().toString() + this.monthTextToInt(this.monthList[prevQuarterEndDate.getMonth()]) + this.monthDayNumToInt(prevQuarterEndDate.getDate()));
					fromDateIndex = toDateIndex;
				}
				else if (["pfy"].includes(this.state.presetSelection)) {
					let prevYear = parseInt(toDateIndex.toString().substring(0, 4)) - 1;
					fromDateIndex = parseInt(prevYear.toString() + "0101");
					toDateIndex = parseInt(prevYear.toString() + "1231");
				}

				for (var i = 0; i < this.props.calendarSpread[calKey].length; i++) {
					let cal = this.props.calendarSpread[calKey][i];
					if (toDateIndex >= cal.start && toDateIndex <= cal.end) {

						if (["2wtd"].includes(this.state.presetSelection) && i != 0) {
							fromDateIndex = this.props.calendarSpread[calKey][i - 1].start;
						} else {
							fromDateIndex = cal.start;
						}
						if (["pf2w"].includes(this.state.presetSelection) && i != 0) {
							fromDateIndex = this.props.calendarSpread[calKey][i - 1].start;
							toDateIndex = cal.end;
						}
						if (["pfy", "pfq", "pfm", "pfw"].includes(this.state.presetSelection) && i != 0) {
							fromDateIndex = cal.start;
							toDateIndex = cal.end;
						}
						break;
					}
					else if (toDateIndex >= this.intYearAdd(-1, cal.start) && toDateIndex <= this.intYearAdd(-1, cal.end)) {

						if (["2wtd"].includes(this.state.presetSelection) && i != 0) {
							fromDateIndex = this.intYearAdd(-1, this.props.calendarSpread[calKey][i - 1].start);
						} else {
							fromDateIndex = this.intYearAdd(-1, cal.start);
						}
						if (["pf2w"].includes(this.state.presetSelection) && i != 0) {
							fromDateIndex = this.intYearAdd(-1, this.props.calendarSpread[calKey][i - 1].start);
							toDateIndex = this.intYearAdd(-1, cal.end);
						}
						if (["pfy", "pfq", "pfm", "pfw"].includes(this.state.presetSelection) && i != 0) {
							fromDateIndex = this.intYearAdd(-1, cal.start);
							toDateIndex = this.intYearAdd(-1, cal.end);
						}
						break;
					}
				}
				this.props.setTimeRange(fromDateIndex, toDateIndex);
			}
		}
	}

	autoSelectToday(isToDay) {
		let todayDateIndexString = moment().format("YYYYMMDD");
		let year = todayDateIndexString.substring(0, 4);
		let month = this.monthList[parseInt(todayDateIndexString.substring(4, 6)) - 1]
		let day = todayDateIndexString.substring(6, 8);

		if (isToDay) {
			this.setState({
				toYear: year,
				toMonth: month,
				toDay: day,
				phase: 6
			})
		} else {
			this.setState({
				fromYear: year,
				fromMonth: month,
				fromDay: day,
				toYear: null,
				toMonth: null,
				toDay: null,
				phase: this.isSingleDate() ? 6 : 3
			})
		}
	}

	resetCalendar() {
		this.setState({
			fromYear: null,
			fromMonth: null,
			fromDay: null,
			toYear: null,
			toMonth: null,
			toDay: null,
			phase: 0
		})
	}

	selectFromYear(year) {
		this.setState({
			fromYear: year,
			fromMonth: null,
			fromDay: null,
			toYear: null,
			toMonth: null,
			toDay: null,
			phase: 1
		})
	}

	selectFromMonth(month) {
		this.setState({
			fromMonth: month,
			fromDay: null,
			toYear: null,
			toMonth: null,
			toDay: null,
			phase: 2
		})
	}

	selectFromDay(day) {
		this.setState({
			fromDay: day,
			toYear: null,
			toMonth: null,
			toDay: null,
			phase: this.isSingleDate() ? 6 : 3
		})
	}

	selectToYear(year) {
		this.setState({
			toYear: year,
			toMonth: null,
			toDay: null,
			phase: 4
		})
	}

	selectToMonth(month) {
		this.setState({
			toMonth: month,
			toDay: null,
			phase: 5
		})
	}

	selectToDay(day) {
		this.setState({
			toDay: day,
			phase: 6
		})
	}

	generatePresetSlide() {


		return (
			<div className={"slide " + (this.state.activeSlideIndex === 0 ? "center" : "left")}>
				<div className={"title"}>{"Choose a quick range"}</div>
				<div className={"preset-selection-container"}>
					<div data-trackid={'dates-singleDate'} className={"button"} onClick={this.selectPreset.bind(null, "single")}>{"Single Date"}</div>
					<div data-trackid={'dates-customRange'} className={"button"} onClick={this.selectPreset.bind(null, "custom")}>{"Custom Range"}</div>
					<div data-trackid={'dates-previousFullWeek'} className={"button"} onClick={this.selectPreset.bind(null, "pfw")}>{"Previous Full Week"}</div>
					<div data-trackid={'dates-weekToDate'} className={"button"} onClick={this.selectPreset.bind(null, "wtd")}>{"Week to Date"}</div>
					<div data-trackid={'dates-previousTwoFullWeeks'} className={"button"} onClick={this.selectPreset.bind(null, "pf2w")}>{"Previous Full 2 Weeks"}</div>
					<div data-trackid={'dates-twoWeeksToDate'} className={"button"} onClick={this.selectPreset.bind(null, "2wtd")}>{"2 Weeks to Date"}</div>
					<div data-trackid={'dates-previousFullMonth'} className={"button"} onClick={this.selectPreset.bind(null, "pfm")}>{"Previous Full Month"}</div>
					<div data-trackid={'dates-monthToDate'} className={"button"} onClick={this.selectPreset.bind(null, "mtd")}>{"Month to Date"}</div>
					<div data-trackid={'dates-previousFullQuarter'} className={"button"} onClick={this.selectPreset.bind(null, "pfq")}>{"Previous Full Quarter"}</div>
					<div data-trackid={'dates-quarterToDate'} className={"button"} onClick={this.selectPreset.bind(null, "qtd")}>{"Quarter to Date"}</div>
					<div data-trackid={'dates-previousFullYear'} className={"button"} onClick={this.selectPreset.bind(null, "pfy")}>{"Previous Full Year"}</div>
					<div data-trackid={'dates-yearToDate'} className={"button"} onClick={this.selectPreset.bind(null, "ytd")}>{"Year to Date"}</div>

				</div>
			</div>
		)
	}

	generateCalendarSlide() {

		let calendarPieces = [];

		let nowDate = moment();
		let nowYear = nowDate.year()
		let nowMonth = nowDate.month()
		let nowDay = nowDate.date()
		let nowDayOfWeek = nowDate.day()

		let yearList = [(nowYear - 2).toString(), (nowYear - 1).toString(), nowYear.toString()]
		let monthList = this.monthList;
		let dayList = this.dayList;
		let dayOfWeekList = this.dayOfWeekList;

		let topBase = 3.5;

		let yearIndexBase = 0;
		// if ([].includes(this.state.presetSelection)) {
		if (true) {
			yearIndexBase = 2;
			calendarPieces.push((
				<div
					key={`calendar-from-year-piece-today-selector-1`}
					className={"calendar-piece year start" +
						(this.state.phase != 0 ? " hidden" : "")
					}
					style={{
						left: "calc(50% - 2.5rem)",
						top: (topBase) + 'rem',
						transitionDelay: (Math.random() / 3) + 's'
					}}
					onClick={this.autoSelectToday.bind(null, false)}
				>
					{"Today"}
				</div>
			))
		}
		yearList.forEach((year, index) => {
			let isSelected = this.state.fromYear === year
			calendarPieces.push((
				<div
					key={`calendar-from-year-piece-${year}`}
					className={"calendar-piece year start" +
						(isSelected ? " selected" : "") +
						(this.state.phase != 0 && !isSelected ? " hidden" : "")
					}
					style={{
						left: "calc(50% - 2.5rem)",
						top: (topBase + yearIndexBase + index * 1.5) + 'rem',
						transitionDelay: (Math.random() / 3) + 's'
					}}
					onClick={!isSelected ? this.selectFromYear.bind(null, year) : this.resetCalendar}
				>
					{year}
				</div>
			))
		})

		monthList.forEach((month, index) => {
			let isSelected = this.state.fromMonth === month
			calendarPieces.push((
				<div
					key={`calendar-from-month-piece-${month}`}
					className={"calendar-piece month start" +
						(isSelected ? " selected" : "") +
						(this.state.phase != 1 && !isSelected ? " hidden" : "")
					}
					style={{
						left: (3.25 + index % 3 * 5) + "rem",
						top: (topBase + Math.floor(index / 3) * 1.5) + 'rem',
						transitionDelay: (Math.random() / 3) + 's'
					}}
					onClick={!isSelected ? this.selectFromMonth.bind(null, month) : this.selectFromYear.bind(null, this.state.fromYear)}
				>
					{month}
				</div>
			))
		})

		dayOfWeekList.forEach((dow, index) => {
			calendarPieces.push((
				<div
					key={`calendar-from-dayofweek-piece-${dow}`}
					className={"calendar-piece day start" +
						(this.state.phase != 2 && this.state.phase != 5 ? " hidden" : "")
					}
					style={{
						cursor: 'unset',
						left: (1.5 + index % 7 * 2.6428) + "rem",
						top: topBase + 'rem',
						transitionDelay: (Math.random() / 3) + 's'
					}}
				>
					{dow}
				</div>
			))
		})

		let fromDayOffset = 0;
		let fromDayLimit = 31;
		if (this.state.fromYear != null && this.state.fromMonth != null) {
			fromDayOffset = moment((monthList.indexOf(this.state.fromMonth) + 1) + '/01/' + this.state.fromYear).day()
			fromDayLimit = moment((monthList.indexOf(this.state.fromMonth) + 1) + '/01/' + this.state.fromYear).add('months', 1).date(0).date()
		}

		dayList.forEach((day, index) => {
			let isSelected = this.state.fromDay === day
			calendarPieces.push((
				<div
					key={`calendar-from-day-piece-${day}`}
					className={"calendar-piece day start" +
						(isSelected ? " selected" : "") +
						((this.state.phase != 2 && !isSelected) || index >= fromDayLimit ? " hidden" : "")
					}
					style={{
						left: (1.5 + (index + fromDayOffset) % 7 * 2.6428) + "rem",
						top: (topBase + (Math.floor((index + fromDayOffset) / 7) + 1) * 1.5) + 'rem',
						transitionDelay: (Math.random() / 3) + 's'
					}}
					onClick={!isSelected ? this.selectFromDay.bind(null, day) : this.selectFromMonth.bind(null, this.state.fromMonth)}
				>
					{day}
				</div>
			))
		})

		if (this.state.fromYear != null && this.state.fromMonth != null && this.state.fromDay != null) {
			yearIndexBase = 0;
			if (parseInt(this.state.fromYear + this.monthTextToInt(this.state.fromMonth) + this.state.fromDay) <= parseInt(moment().format("YYYYMMDD"))) {
				yearIndexBase = 2;
				calendarPieces.push((
					<div
						key={`calendar-from-year-piece-today-selector-2`}
						className={"calendar-piece year end" +
							(this.state.phase != 3 ? " hidden" : "")
						}
						style={{
							left: "calc(50% - 2.5rem)",
							top: (topBase) + 'rem',
							transitionDelay: (Math.random() / 3) + 's'
						}}
						onClick={this.autoSelectToday.bind(null, true)}
					>
						{"Today"}
					</div>
				))
			}
			yearList.forEach((year, index) => {
				let isSelected = this.state.toYear === year
				calendarPieces.push((
					<div
						key={`calendar-to-year-piece-${year}`}
						className={"calendar-piece year end" +
							(isSelected ? " selected" : "") +
							(this.state.phase != 3 && !isSelected ? " hidden" : "") +
							(year < this.state.fromYear ? " disabled" : "")
						}
						style={{
							left: "calc(50% - 2.5rem)",
							top: (topBase + yearIndexBase + index * 1.5) + 'rem',
							transitionDelay: (Math.random() / 3) + 's'
						}}
						onClick={!isSelected ? this.selectToYear.bind(null, year) : this.selectFromDay.bind(null, this.state.fromDay)}
					>
						{year}
					</div>
				))
			})

			monthList.forEach((month, index) => {
				let isSelected = this.state.toMonth === month
				calendarPieces.push((
					<div
						key={`calendar-to-month-piece-${month}`}
						className={"calendar-piece month end" +
							(isSelected ? " selected" : "") +
							(this.state.phase != 4 && !isSelected ? " hidden" : "") +
							(this.state.toYear != null &&
								(this.state.toYear + this.monthTextToInt(month)) < (this.state.fromYear + this.monthTextToInt(this.state.fromMonth)) ? " disabled" : "")
						}
						style={{
							left: (3.25 + index % 3 * 5) + "rem",
							top: (topBase + Math.floor(index / 3) * 1.5) + 'rem',
							transitionDelay: (Math.random() / 3) + 's'
						}}
						onClick={!isSelected ? this.selectToMonth.bind(null, month) : this.selectToYear.bind(null, this.state.toYear)}
					>
						{month}
					</div>
				))
			})

			let toDayOffset = 0;
			let toDayLimit = 31;
			if (this.state.toYear != null && this.state.toMonth != null) {
				toDayOffset = moment((monthList.indexOf(this.state.toMonth) + 1) + '/01/' + this.state.toYear).day()
				toDayLimit = moment((monthList.indexOf(this.state.toMonth) + 1) + '/01/' + this.state.toYear).add('months', 1).date(0).date()
			}

			dayList.forEach((day, index) => {
				let isSelected = this.state.toDay === day
				calendarPieces.push((
					<div
						key={`calendar-to-day-piece-${day}`}
						className={"calendar-piece day end" +
							(isSelected ? " selected" : "") +
							((this.state.phase != 5 && !isSelected) || index >= toDayLimit ? " hidden" : "") +
							(this.state.toYear != null && this.state.toMonth != null &&
								(this.state.toYear + this.monthTextToInt(this.state.toMonth) + day) < (this.state.fromYear + this.monthTextToInt(this.state.fromMonth) + this.state.fromDay) ? " disabled" : "")
						}
						style={{
							left: (1.5 + (index + toDayOffset) % 7 * 2.6428) + "rem",
							top: (topBase + (Math.floor((index + toDayOffset) / 7) + 1) * 1.5) + 'rem',
							transitionDelay: (Math.random() / 3) + 's'
						}}
						onClick={!isSelected ? this.selectToDay.bind(null, day) : this.selectToMonth.bind(null, this.state.toMonth)}
					>
						{day}
					</div>
				))
			})
		}


		return (
			<div className={"slide " + (this.state.activeSlideIndex === 1 ? "center" : "right")}>
				<div className={"calendar-selection-container" + (this.isSingleDate() ? " single-date" : "") + (this.state.phase === 6 ? " final" : "")}>
					<div className={"calendar-label start"}>{this.isSingleDate() ? this.getTimeRangeDescription() : "Start"}</div>
					<div className={"calendar-label end"}>{this.isSingleDate() ? "" : "End"}</div>
					{calendarPieces}
					<div className={"time-range-label"}>{this.getTimeRangeLabel()}</div>
					<div className={"finalize-button"} onClick={this.finalizeDates}>{"SET RANGE"}</div>
				</div>
			</div>
		)
	}

	render() {

		return (
			<div className={"workspace-time-picker-outer" + (!this.props.isActive ? " hidden" : "")}>
				{this.generatePresetSlide()}
				{this.generateCalendarSlide()}
				<div className={"material-icons back-button" + (this.state.activeSlideIndex === 0 ? " hidden" : "")} onClick={this.backPressed}>{"keyboard_backspace"}</div>
				<div className={"material-icons exit-button"} onClick={this.props.setTimeOpen.bind(null, false)}>{"close"}</div>
			</div>
		);
	}
}